import { render, staticRenderFns } from "./RemitoEstado.vue?vue&type=template&id=50af62a3"
import script from "./RemitoEstado.vue?vue&type=script&lang=js"
export * from "./RemitoEstado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports